

import { ar } from './ar'
import { da } from './da'
import { de } from './de'
import { en } from './en'
import { es } from './es'
import { fi } from './fi'
import { fr } from './fr'
import { ja } from './ja'
import { ko } from './ko'
import { nb } from './nb'
import { nl } from './nl'
import { pt } from './pt'
import { sv } from './sv'
import { zh_CN } from './zh_CN'
import { zh_TW } from './zh_TW'
export const allTranslations = {
  ar: ar,
  da: da,
  de: de,
  en: en,
  es: es,
  fi: fi,
  fr: fr,
  ja: ja,
  ko: ko,
  nb: nb,
  nl: nl,
  pt: pt,
  sv: sv,
  zh_CN: zh_CN,
  zh_TW: zh_TW
}
